import { render } from "./video.vue?vue&type=template&id=22bdb902&scoped=true"
import script from "./video.vue?vue&type=script&lang=js"
export * from "./video.vue?vue&type=script&lang=js"

import "./video.vue?vue&type=style&index=0&id=22bdb902&scoped=true&lang=css"
import "./video.vue?vue&type=style&index=1&id=22bdb902&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22bdb902"]])

export default __exports__